export default "__VITE_ASSET__Dwdd71NK__"